import { Link } from 'react-router-dom';

import type { EventState, Venue } from '@/types';
import { fmtDate } from '@/lib/format';
import { useI18n } from '@/providers/i18n';

import styles from './EventDetailHeader.module.css';

interface EventDetailHeaderProps {
  event: {
    code: string;
    date: string;
    state?: EventState;
  };
  venue: Venue;
  archived?: boolean;
}

const STATE_LABEL: Record<EventState, string> = {
  available: 'ON SALE',
  low: 'CLOSING',
  'sold-out': 'SOLD OUT',
  waitlist: 'WAITLIST',
};

export default function EventDetailHeader({ event, venue, archived = false }: EventDetailHeaderProps) {
  const { lang } = useI18n();
  const dd = fmtDate(event.date, lang);
  const statusLabel = archived ? 'ARCHIVE' : event.state ? STATE_LABEL[event.state] : '';
  const pulse = !archived && (event.state === 'available' || event.state === 'low');

  return (
    <div className={styles.strip}>
      <span className={styles.crumbs}>
        <Link to="/">MOCT</Link>
        <span className={styles.sep}>/</span>
        <Link to="/events">EVENTS</Link>
        <span className={styles.sep}>/</span>
        <span className={styles.code}>{event.code}</span>
      </span>
      <span className={styles.spec}>
        {dd.day} {dd.month} {dd.year} · {venue.name}
      </span>
      <span className={styles.live}>
        {pulse ? <i className={styles.pulse} /> : null}
        {statusLabel}
      </span>
    </div>
  );
}
